export default __webpack_public_path__ + "static/media/feedingthepyre.c1449c4a.png";